module.exports = __webpack_public_path__ + "static/media/bfile-disabled.eb28e274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-disabled.svg
// module id = 3104
// module chunks = 0